export enum Store {
  Declaration = 'declaration',
  Subscriber = 'subscriber',
  Offer = 'offer',
  DirectDebit = 'direct_debit',
}
